export default "__VITE_ASSET__BPINcTPZ__"